module.exports = __webpack_public_path__ + "img/selected2-min.de05436f.png";